import { create, type StateCreator } from "zustand"

interface LeftActivityAlertState {
  isOpen: boolean
  redirectUrl: string
  onOpen: (redirectUrl?: string) => void
  onClose: () => void
  clearState: () => void
}

const state: StateCreator<LeftActivityAlertState> = (set, get) => ({
  isOpen: false,
  redirectUrl: "/study",
  onOpen: (redirectUrl?: string) => {
    set({
      isOpen: true,
      redirectUrl: redirectUrl || get().redirectUrl,
    })
  },
  onClose: () => {
    set({
      isOpen: false,
    })
  },
  clearState: () => {
    set({
      isOpen: false,
      redirectUrl: "/study",
    })
  },
})

export const useLeftActivityAlertStore = create<LeftActivityAlertState>()(state)
